import { client } from "api";

export type CreateAccountRequest = {
  signUpCode: string;
  userName: string;
  email: string;
  phone: number;
  password: string;
  confirmPassword: string;
  appleId: string | null;
  requestedCompanyName: string;
};

export type CreateAccountResponse = {
  id: string;
};

export const createAccount = async (formData: CreateAccountRequest) =>
  client.post<CreateAccountResponse>(`/user/register`, formData).then((res) => res.data);
